import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import config from 'devextreme/core/config';
import { DEVEXTREME_LICENSE_KEY } from './devextreme-license';
import { RuntimeEnvironmentService } from '@gah-core/services/runtime-environment.service';

config({ licenseKey: DEVEXTREME_LICENSE_KEY }); 

const runtimeService = new RuntimeEnvironmentService();
const runtimeEnv = runtimeService.environment;

// Populate the mutable environment object with runtime values
if (runtimeEnv) {
  Object.assign(environment, runtimeEnv);
  console.log(`Main: Application running in ${runtimeService.environmentName} environment`);
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
